module.exports = __webpack_public_path__ + "assets/arrow-expand.57ca823c.svg";